import { Component, OnInit } from '@angular/core';
import { SearchService } from '../../search/search.service';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { ModalService } from '../../services/modal.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { SearchCriteria, Condition, Clause } from '../../search/models/search-filter-model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchEvent } from '../../search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../search/search-constants';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { AlertService, ResourceService } from 'sce-core';
import { ButtonItem } from '../../button/button.model';
import { Subject, Observable } from 'rxjs';
import { FileImportService } from '../../services/file-import.service';
import { LocalPagedSearchService } from '../../search/localpaged-search.service';

@Component({
  selector: 'lfwms-channel-inv-hold-import-popup',
  templateUrl: './channel-inv-hold-import-popup.component.html',
  styleUrls: ['./channel-inv-hold-import-popup.component.css']
})
export class ChannelInvHoldImportPopupComponent implements OnInit {


  public importSearchService: SearchService;
  public eventSubject = new Subject<any>();
  public buttonPanelButtonArray = [
    new ButtonItem('Import', this.resourceService.get('lbl_import'),
      'chnl_invh_pop_import', 'icon-import.svg', [], { buttonType: 'UploadImport' }),
    new ButtonItem('Save', this.resourceService.get('btn_post'),
      'chnl_invh_pop_post', 'icon_save.svg', []),
    new ButtonItem('Cancel', this.resourceService.get('btn_cancel'),
      'chnl_invh_pop_canc', 'icon-cancel.svg', []),
  ];
  public columnMap = {
    'Channel_ID': 'channel_id',
     'Hold':'hold',
     'Qty':'QtyHoldToAdj',
     'Remarks':'remarks'
  };

  constructor(public modalService: ModalService,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService,
    private fileImportService: FileImportService,
    private resourceService: ResourceService) { }

  ngOnInit() {
  }

  public initializeComponents() {
    // this.initializeSearchService();
    const searchParams = new SearchParams();
    searchParams.tableId = 'channelimporttd';
    // LFWM-3191-fix to load buttons by privilege in popups.
    searchParams.actionButtons = this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.buttonPanelButtonArray);
    searchParams.paginateLocally = true;
    const tableConfig: DataTableConfig = new DataTableConfig();
    searchParams.dataTableConfig = tableConfig;
    const searchStatus = new SearchStatus();
    searchStatus.hasResults = true;
    this.importSearchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    this.importSearchService.fetchMetadata().subscribe(data => {
    });
  }

  public initializeSearchService() { }

  public handleButtonAction(action: any) {
    if (action === 'Import') {
      this.importSearchService.fullData = [];
      const result = this.fileImportService.transformDataFromImportFile(action,
        <LocalPagedSearchService>this.importSearchService, 'channelimporttd', '', this.columnMap);
      if (result === 'success') {
        this.importSearchService.fullData.forEach(row => {
          if (parseInt(row.cells['hold'].cVal, 10) !== 1) {
            this.alertService.clearAll().error(this.resourceService.get('err_msg_hold_zero_found'));
            this.importSearchService.fullData = [];
          }
        });
        this.importSearchService.performSearch();
      } else {
        this.alertService.clearAll().error(this.resourceService.get(result));
      }
    } else if (action === 'Save') {
      const noOfLineItems = this.importSearchService.getPagedData().pageRows.length;
      if (noOfLineItems === 0) {
        this.alertService.clearAll().error(this.resourceService.get('msg_no_detail'));
        return;
      }
      const selectedRows = this.importSearchService.getSelectedRows();
      if (selectedRows.length === 0) {
        this.alertService.clearAll().error(this.resourceService.get('msg_sel_detail'));
        return;
      }
      this.notifyEvent({'type': 'Save', 'selectedRows': selectedRows });
    } else if (action === 'Cancel') {
      this.notifyEvent({'type': 'Cancel'});
    }
  }

  public notifyEvent(value: any) {
    this.eventSubject.next(value);
  }

  public receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();
  }


}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/channel-inv-hold-import-popup/channel-inv-hold-import-popup.component.ts